import {createAction} from '@reduxjs/toolkit';

export const selectItemTypes = createAction('SELECT_ITEM_TYPES');
export const resetSelectedItemTypes = createAction('RESET_SELECTED_ITEM_TYPES');
